module.exports = "<ng-template mp-flowplayer-renderer></ng-template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/flowplayer/flowplayer.html
// module id = N21w
// module chunks = 3